import api from "../../../services/api";
import type { PeriodType } from "../hooks/useAccountingDashboard";


export const getAccountingOverview = async (periodType: PeriodType) => {
  const response = await api.get(`/api/accounting/revenue_overview`, {
    params: { period_type: periodType },
  });
  return response.data.accounting_dashboard;
};
